import { render } from "./WelcomeTextContainer.vue?vue&type=template&id=7ff3d753&scoped=true"
import script from "./WelcomeTextContainer.vue?vue&type=script&lang=js"
export * from "./WelcomeTextContainer.vue?vue&type=script&lang=js"

import "./WelcomeTextContainer.vue?vue&type=style&index=0&id=7ff3d753&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff3d753"]])

export default __exports__